import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: false
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    showLoad: (state) => {
      // console.log("showLoad");
      state.status = true;
    },
    dismissLoad: (state) => {
      // console.log("dismissLoad");
      state.status = false;
    },
  }
});

export const selectLoading = (state = {}) => state.loading;

export const { showLoad, dismissLoad } = loadingSlice.actions;

export default loadingSlice.reducer;
